@if (users().length) {
  <form
    class="kr-wallet-users"
    [formGroup]="form"
    data-testid="wallet_details_users_form">
    <fu-multi-select
      class="kr-wallet-users__select"
      formControlName="users"
      [items]="users()"
      [label]="'walletUsers.users.label' | translate"
      data-testid="wallet_details_users_multi_select">
    </fu-multi-select>

    @if (selectedUsers().length) {
      <div
        class="kr-wallet-users__selected-users"
        data-testid="wallet_details_users_selected_users">
        @for (user of selectedUsers(); track user.id) {
          <button
            class="kr-wallet-users__btn-remove"
            (click)="remove(user)"
            [attr.data-testid]="'wallet_details_users_btn_remove' + user.id">
            {{ user.name }}
            <fu-icon
              iconName="trash"
              data-testid="wallet_details_users_icon_trash"></fu-icon>
          </button>
        }
      </div>
    } @else {
      <fu-empty
        iconName="users"
        titleKey="walletUsers.empty.title"
        secondaryBtnLink
        data-testid="wallet_details_users_empty">
      </fu-empty>
    }
  </form>
}
